import { createAction } from 'redux-actions';

import { BillingType, BillingDetailsShortType, BillingAddressType } from '@ts/billing-app.types';

export const setAppBillingCreditsLs = createAction<string>('SET_APP_BILLING_CREDITS_LS');
export const setAppBillingCreditsData = createAction<BillingDetailsShortType>(
  'SET_APP_BILLING_CREDITS_DATA'
);
export const setAppBillingLs = createAction<string>('SET_APP_BILLING_LS');
export const setAppBillingData = createAction<BillingType>('SET_APP_BILLING_DATA');
export const setAppBillingAddressLs = createAction<string>('SET_APP_BILLING_ADDRESS_LS');
export const setAppBillingAddressData = createAction<BillingAddressType>('SET_APP_BILLING_ADDRESS_DATA');
